import { useHttpClient } from "../http-client";

export const useGetConversationSummaryApi = (
  organizationId: string,
  responseId: string
) => {
  const httpClient = useHttpClient();

  const getSummary = async (): Promise<string> => {
    // The support-summaries endpoint lives at the backend root under `/api`,
    // unlike the `/classifier/*` endpoints. In dev the Vite proxy strips the
    // leading `/api` (baseURL), so requesting `/api/responses/...` resolves to
    // `/api/api/responses/...` -> backend `/api/responses/...`. In prod the
    // baseURL is the absolute backend host, so the same path resolves directly.
    const summaryPath = `/api/responses/${responseId}/support_summaries`;
    const res = await httpClient.post(
      summaryPath,
      {},
      {
        headers: {
          Tenant: organizationId,
          Accept: "text/plain",
        },
        responseType: "text",
      }
    );

    const data = res.data;
    if (typeof data === "string") {
      try {
        const parsed = JSON.parse(data);
        return (
          parsed?.summary ||
          parsed?.support_summary?.summary ||
          parsed?.data?.summary ||
          parsed?.data?.attributes?.summary ||
          parsed?.data?.attributes?.support_summary?.summary ||
          data
        );
      } catch {
        return data;
      }
    }
    return (
      data?.summary ||
      data?.support_summary?.summary ||
      data?.data?.summary ||
      data?.data?.attributes?.summary ||
      data?.data?.attributes?.support_summary?.summary ||
      ""
    );
  };

  return getSummary;
};
